import { createQueryKeys } from '@codes/base-api';

export const ownerQueryKeys = createQueryKeys('owners');
